export const ooraPlanReducer = (
  state = {
    plans: null,
    planDetail: null,
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case "LIST_OORA_PLANS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "LIST_OORA_PLANS_SUCCESS":
      return {
        ...state,
        loading: false,
        plans: action.payload,
        error: null,
      };
    case "LIST_OORA_PLANS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "ADD_OORA_PLAN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ADD_OORA_PLAN_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "ADD_OORA_PLAN_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_OORA_PLAN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_OORA_PLAN_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "UPDATE_OORA_PLAN_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_OORA_PLAN_STATUS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_OORA_PLAN_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "UPDATE_OORA_PLAN_STATUS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "LIST_OORA_PAYMENTS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "LIST_OORA_PAYMENTS_SUCCESS":
      return {
        ...state,
        loading: false,
        payments: action.payload,  
        error: null,
      };
    case "LIST_OORA_PAYMENTS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
